import TotalAdjustmentCard from './TotalAdjustmentCard';
export default TotalAdjustmentCard;
